import React from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket, faTable, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const SideMenu = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access_token");
  const token = jwt_decode(accessToken);
  const isHR = token?.realm_access?.roles?.includes("facetime_admin");

  const personnelClick = () => {
    navigate("/Personnel");
  };
  const departmentClick = () => {
    navigate("/Department");
  };
  const attendanceClick = () => {
    navigate("/AttendanceByName");
  };
  const attendanceMonthClick = () => {
    navigate("/AttendanceMonthly");
  };
  const absenteeismClick = () => {
    navigate("/Absenteeism");
  };
  const depStatisticsClick = () => {
    navigate("/Department_Statistics");
  };
  const depStaDetailsClick = () => {
    navigate("/Department_Statistics_Details");
  };
  const manageDepClick =()=>{
    navigate("/ManageDepartment");
  }
  const manageEmpClick =()=>{
    navigate("/ManageEmployee");
  }
  // const userClick = () => {
  //   navigate("/User_Management");
  // };
  const logoutClick = () => {
    navigate("/");
  };
  return (
    <div>
      <Navbar expand="lg" variant="dark">
        <Nav className="mr-auto flex-column">
          <div  />

          {isHR && (
            <>
            <NavItem>
              <Nav.Link
                disabled
                style={{ color: "#8C8C8C", fontWeight: "bolder" }}
              >
                <FontAwesomeIcon icon={faTable} />
                REPORT
              </Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={personnelClick}>PERSONNEL</Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={departmentClick}>DEPARTMENT</Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={attendanceClick}>ATTENDANCE</Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={attendanceMonthClick}>ATTENDANCE MONTHLY</Nav.Link>
            </NavItem>
            {/* <NavItem>
              <Nav.Link onClick={absenteeismClick}>ABSENTEEISM</Nav.Link>
            </NavItem> */}
            <NavItem>
              <Nav.Link onClick={depStatisticsClick}>
                DEPARTMENT STATISTICS
              </Nav.Link>
            </NavItem>
            {/* <NavItem>
              <Nav.Link onClick={depStaDetailsClick}>
                DEPARTMENT STATISTICS-DETAILS
              </Nav.Link>
            </NavItem> */}
            <NavItem>
              <Nav.Link disabled style={{ color: "#8C8C8C", fontWeight: "bolder" }}><hr />
                <FontAwesomeIcon icon={faUserCircle} />
                MISC MANAGEMENT
              </Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={manageDepClick}>MANAGE DEPARTMENT</Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={manageEmpClick}>MANAGE EMPLOYEE</Nav.Link>
            </NavItem>
            {/* <NavItem>
              <Nav.Link onClick={userClick}>
                {" "}
                <hr />
                USER MANAGEMENT
              </Nav.Link>
            </NavItem> */}
            </>
          )}
          <NavItem>
            <Nav.Link onClick={logoutClick}>
              <hr />
              {/* <FontAwesomeIcon icon={faRightFromBracket} /> LOGOUT */}
              {/* <FontAwesomeIcon icon={faRightFromBracket} style={{ color: 'red' }} /> LOGOUT */}
              <span style={{ color: 'red' }}>
                <FontAwesomeIcon icon={faRightFromBracket} /> LOGOUT
              </span>
            </Nav.Link>
          </NavItem>
        </Nav>
      </Navbar>
    </div>
  );
};

export default SideMenu;
